export const SECOND = 1000
export const MINUTE = SECOND * 60
export const HOUR = MINUTE * 60
export const DAY = HOUR * 24

export const TASK_DURATION_RESCUE = 30 * MINUTE
export const TASK_DURATION_REFUEL = 20 * MINUTE
export const TASK_DURATION_UNLOAD = 5 * MINUTE
